export default "__VITE_ASSET__f123598b__"